<label class="flex gap-1 pl-2">Folder</label>

<unified-ui-loader [isLoading]="isLoading()"></unified-ui-loader>
<p-tree
    class="unified-p-tree p-tree-without-inverse-selection no-select-all"
    [value]="folders$ | async"
    [draggableNodes]="true"
    [droppableNodes]="true"
    selectionMode="single"
    [(selection)]="selectedFolder"
    (onNodeSelect)="selectedFolderId.emit($event.node.key!)"
    (onNodeUnselect)="selectedFolderId.emit(null)"
    draggableScope="self"
    droppableScope="self"
    (onNodeDrop)="editFolderParent($event)"
    [filter]="true"
    [trackBy]="treeTrackBy"
    filterPlaceholder="Filter"
    (onNodeExpand)="hideLastContextFolderMenu()"
    (onNodeCollapse)="hideLastContextFolderMenu()">
    <ng-template pTemplate="filtericon"><i class="pi pi-filter"></i></ng-template>
    <ng-template
        let-node
        pTemplate="default">
        <div
            class="folder-name-info"
            #folderNameInfo
            (contextmenu)="setSelectedFolder(node, contextMenu); checkDeleting(node)">
            @if (editingFolderNameId() === node.key) {
            <div class="folder-name-info__edit">
                <input
                    pInputText
                    type="text"
                    #inlineNameInput
                    [(ngModel)]="newFolderName"
                    placeholder="Please provide name"
                    [required]="true"
                    minlength="3"
                    maxlength="30"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()" />
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-check-circle"
                    class="p-button-rounded p-button-text p-button-sm"
                    [disabled]="!newFolderName"
                    (click)="isFolderBeingCreated ? saveNewFolder(node) : editFolderName(node, newFolderName)"></button>
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-times-circle"
                    class="p-button-rounded p-button-text p-button-sm"
                    severity="danger"
                    (click)="isFolderBeingCreated ? cancelFolderCreation() : editFolderName()"></button>
            </div>
            } @else {
            <span
                pTooltip="Right Click to Edit"
                tooltipPosition="top">
                <i class="pi pi-icon pi-folder"></i>
                {{ node.label }}</span>
            }
            <p-contextmenu
                #contextMenu
                [target]="folderNameInfo"
                [model]="completeMenuItems()"
                appendTo="body">
            </p-contextmenu>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="folder-content__footer">
            <div
                [pTooltip]="'Create New Folder'"
                tooltipPosition="top"
                (click)="createNewFolder()">
                <i class="pi pi-plus-circle mr-2"></i>New folder
            </div>
        </div>
    </ng-template>
</p-tree>
<p-confirmDialog key="folder-confirm-delete" />